import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortDirection } from 'config';
import { ITopUser } from 'interfaces';
import { ITopUserState } from './topUsers.types';

const initialState: ITopUserState = {
  topUsers: [],
  isLoading: false,
  error: null,
  sortDirection: SortDirection.DESC,
};

export const topUserReducer = createSlice({
  name: 'topUsers',
  initialState,
  reducers: {
    setTopUsersLoading: (state) => {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    },
    setTopUsersSuccess: (state, action: PayloadAction<ITopUser[]>) => {
      return {
        ...state,
        topUsers: action.payload,
        isLoading: false,
        error: null,
      };
    },
    setTopUsersError: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
    setSortDirection: (state, action: PayloadAction<SortDirection>) => {
      return {
        ...state,
        sortDirection: action.payload,
      };
    },
  },
});

export const {
  setTopUsersLoading,
  setTopUsersSuccess,
  setTopUsersError,
  setSortDirection,
} = topUserReducer.actions;

export default topUserReducer.reducer;
